
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"m0 0h24v24h-24z"}})]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"m9.50025 15.0824c-.21326 0-.42652-.0813-.589-.2445-.32575-.3258-.32575-.8531 0-1.178l4.99955-4.99956c.3257-.32574.853-.32574 1.178 0 .3257.32575.3257.85304 0 1.17801l-4.9995 4.99955c-.16253.1632-.37579.2445-.58905.2445zm2.45755 2.8873 1.8811-1.8811c.3257-.3257.3257-.853 0-1.178-.3258-.3257-.8531-.3257-1.178 0l-1.8803 1.8803c-.5109.5109-1.18974.7921-1.91077.7921-1.48969 0-2.70213-1.2116-2.70213-2.7013 0-.7226.28121-1.4015.79132-1.9108l1.88106-1.881c.32574-.3258.32574-.8531 0-1.17804-.32575-.32575-.85304-.32575-1.17801 0l-1.88105 1.88024c-.82492.825-1.27956 1.9217-1.27956 3.0895 0 2.4084 1.95997 4.3684 4.36837 4.3684 1.16547-.0016 2.26227-.4554 3.08797-1.2803zm4.3808-4.3816 1.8818-1.881c.8242-.8257 1.278-1.92251 1.278-3.08873.0008-2.40836-1.9584-4.36837-4.3675-4.36837-1.1679 0-2.2646.45464-3.0895 1.27955l-1.8811 1.88106c-.32574.32575-.32574.85303 0 1.178.3258.32575.853.32575 1.178 0l1.8811-1.88105c.5093-.51011 1.1881-.79132 1.9107-.79132 1.4897 0 2.7013 1.21238 2.7013 2.70213 0 .72103-.2804 1.39983-.7905 1.91073l-1.881 1.8811c-.3258.3257-.3258.853 0 1.178.1624.1625.3757.2445.589.2445.214 0 .4272-.0813.5897-.2446z","fill":"#b2895f"}})])])
          )
        }
      }
    